import { usePumpSizing } from "../../../context/PumpSizingContext";
import {
	ORIFICE_FRACTION_OPTIONS,
	PIPE_DIAMETERS,
} from "../../../data/gpm";
import { RadioGroup } from "../../shared/RadioGroup";
import { SelectField } from "../../shared/SelectField";
import { TextField } from "../../shared/TextField";

export function GpmSepticHelp() {
	const { formData, updateSepticGpm } = usePumpSizing();
	const { septic } = formData.gpmData;

	return (
		<div className="pf-gpm-help pf-gpm-help--septic">
			<RadioGroup
				label="System Type"
				name="systemType"
				value={septic.systemType}
				onChange={(value) =>
					updateSepticGpm({
						systemType: value as typeof septic.systemType,
					})
				}
				options={[
					{ value: "conventional", label: "Conventional" },
					{
						value: "lowPressure",
						label: "Low-Pressure Pipe Distribution",
					},
				]}
			/>

			{septic.systemType === "lowPressure" ? (
				<div className="pf-gpm-help__fields">
					<TextField
						label="Distal Pressure/Squirt Height (ft)"
						type="number"
						value={septic.distalPressure}
						onChange={(event) =>
							updateSepticGpm({ distalPressure: event.target.value })
						}
						min="0"
						step="any"
					/>
					<TextField
						label="Total Number of Laterals"
						type="number"
						value={septic.totalLaterals}
						onChange={(event) =>
							updateSepticGpm({ totalLaterals: event.target.value })
						}
						min="0"
						step="1"
					/>
					<TextField
						label="Orifices per lateral"
						type="number"
						value={septic.orificesPerLateral}
						onChange={(event) =>
							updateSepticGpm({ orificesPerLateral: event.target.value })
						}
						min="0"
						step="1"
					/>
					<SelectField
						label="Orifice Size (in)"
						options={ORIFICE_FRACTION_OPTIONS}
						value={septic.orificeFraction}
						onChange={(event) =>
							updateSepticGpm({ orificeFraction: event.target.value })
						}
					/>
				</div>
			) : null}

			{septic.systemType === "conventional" ? (
				<SelectField
					label="Pipe Diameter (in)"
					options={PIPE_DIAMETERS.map((diameter) => ({
						value: diameter,
						label: diameter,
					}))}
					value={septic.pipeDiameter}
					onChange={(event) =>
						updateSepticGpm({ pipeDiameter: event.target.value })
					}
					className="pf-field-group--medium"
				/>
			) : null}
		</div>
	);
}